var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingLog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.425 9.26659C17.425 13.3416 14.4666 17.1583 10.425 18.2749C10.15 18.3499 9.84998 18.3499 9.57498 18.2749C5.53328 17.1583 2.57495 13.3416 2.57495 9.26659V5.60823C2.57495 4.9249 3.09163 4.14991 3.73329 3.89158L8.37498 1.9916C9.41664 1.5666 10.5916 1.5666 11.6333 1.9916L16.275 3.89158C16.9083 4.14991 17.4333 4.9249 17.4333 5.60823L17.425 9.26659Z",
    stroke: "#9061DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.4168C10.9205 10.4168 11.6667 9.67066 11.6667 8.75016C11.6667 7.82969 10.9205 7.0835 10 7.0835C9.07954 7.0835 8.33337 7.82969 8.33337 8.75016C8.33337 9.67066 9.07954 10.4168 10 10.4168Z",
    stroke: "#9061DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.4165V12.9165",
    stroke: "#9061DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingLog);
export default __webpack_public_path__ + "static/media/SettingLog.6b1a65083bf55e66a7593a0718c912dd.svg";
export { ForwardRef as ReactComponent };